import { defineBrowserModule } from "@amtana/browser";
import type { BrowserModule } from "@amtana/browser";
import { phrase } from "@amtana/i18n/catalog";

import { STORE_CATALOGS } from "./model/store-copy.ts";
import { STORE_ERROR_COPY } from "./model/store-error-copy.ts";

// /store is the Seats page under Billing: billing's lent seats panel, then the add-ons, which hide
// behind `add-ons` with their own pages (S43.08, D1368). The path stays, so no link moves.
export const storeBrowserModule: BrowserModule = defineBrowserModule("store")
  .withErrorCopy(STORE_ERROR_COPY)
  .withScreens({
    store: {
      path: "/store",
      title: phrase(STORE_CATALOGS, "titleStore"),
      layout: "app",
      load: () => import("./ui/sections/store-screen.tsx"),
    },
    product: {
      path: "/product/:productId",
      title: phrase(STORE_CATALOGS, "titleProduct"),
      layout: "app",
      flag: "add-ons",
      load: () => import("./ui/sections/product-screen.tsx"),
    },
  })
  .withNavigation([
    {
      id: "store",
      group: "settings-billing",
      label: phrase(STORE_CATALOGS, "navSeats"),
      href: "/store",
      icon: "shopping-bag",
      order: 920,
      activeFor: ["/product/"],
    },
  ]);
